/**
 * Test seams for the e2e suite.
 *
 * Rules for anything added here:
 *  · read from `window` only, and default to false, so it is inert unless a
 *    test sets it before the app boots;
 *  · it may only relax a CLIENT-side gate, never a server-side one.
 *
 * `__E2E_NO_AUTH__` (read in index.tsx) already follows this shape: it swaps
 * Auth0 for a stub provider, but the API still demands a real token, so it
 * cannot grant access to anything.
 */

/**
 * Forces the capture pose gate open.
 *
 * Safe by the design rule the pose registry states as "FE gates, BE flags":
 * the front-end gate decides *when the shutter fires*, and rembg independently
 * re-validates every uploaded image. Forcing this open therefore does not make
 * a bad pose acceptable — it only lets an automated run reach the capture and
 * upload path without a real body in frame.
 *
 * That distinction is why the e2e suite can cover the capture flow without
 * committing photographs of real people to the repository.
 */
export function e2eForcePoseOk(): boolean {
  return typeof window !== 'undefined' && (window as any).__E2E_POSE_OK__ === true;
}
